import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { OpalApiResponseDocument } from '../../../schema'
import { stories } from '../../../v2/stories'
import { globalQueryKeys } from '../../queryKeys'

export type ReadStoriesDocument = OpalApiResponseDocument<'ReadStoriesV2', 200>

export const useWorkspaceStories = <T = ReadStoriesDocument>({
  workspaceId,
  select,
}: {
  workspaceId: number
  select?: (data: ReadStoriesDocument) => T
}): UseQueryResult<T, unknown> => {
  return useQuery({
    queryKey: globalQueryKeys.workspaceStories(workspaceId),
    queryFn: () =>
      stories.read({
        filter: { brand_id: [workspaceId] },
        page: { limit: 9999 },
      }),
    select,
  })
}
